import styles from "./FavouritesList.module.scss";
import { FavouriteSelection } from "../FavouriteSelection";

export const FavouritesList = ({
  markets,
  selectedFavourite,
  setSelectedFavourite,
}) => {
  return (
    <ul className={styles.favouriteSelectionsList}>
      {markets.map((market) => (
        <FavouriteSelection
          key={market.name}
          {...market}
          selectedFavourite={selectedFavourite}
          setSelectedFavourite={setSelectedFavourite}
        />
      ))}
    </ul>
  );
};
